import { render, staticRenderFns } from "./SurfaceDesignColor.vue?vue&type=template&id=08fbf445"
import script from "./SurfaceDesignColor.vue?vue&type=script&lang=js"
export * from "./SurfaceDesignColor.vue?vue&type=script&lang=js"
import style0 from "./SurfaceDesignColor.vue?vue&type=style&index=0&id=08fbf445&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports